import * as axisIntervalsActions from '../../actions/axisIntervalsActions';
import * as chartActionTypes from '../../constants/chart-action-types';
import * as utils from './axisIntervals.utils';

const initialState = {
  xAxisInterval: 'auto',
  mobileXAxisInterval: 'auto',
  mobileXAxisIntervalSameAsDesktop: true,
  yAxisInterval: '',
  yAxisMobileEnabled: true,
  yAxisMobileInterval: '',
  logScale: false,
  mustRender: false,
  majorTicksArticle: 'year',
  minorTicksArticle: 'month',
  majorTicksPrint: 'year',
  minorTicksPrint: 'month',
  majorTicksPromo: 'year',
  minorTicksPromo: 'month',
  hiddenCategoriesArticle: [],
  hiddenCategoriesPrint: [],
  hiddenCategoriesPromo: [],
  minorLabelsVisible: false,
  allowDecimals: true,
  quarterlyResults: false,
};

function axisIntervalsReducer(state = initialState, action) {
  const { payload, stateTree } = action;

  switch (action.type) {
    case chartActionTypes.DESTROY_CHART:
      return initialState;
    case axisIntervalsActions.MUST_RENDER_FALSE:
      return { ...state, mustRender: payload };
    case chartActionTypes.RECEIVE_CHART:
      return utils.fetchAxisIntervalInfo(state, action);
    case axisIntervalsActions.UPDATE_YAXISINTERVAL:
      return utils.updateChart(stateTree, state, payload, 'yAxisInterval');
    case axisIntervalsActions.UPDATE_YAXISMOBILE_ENABLED:
      return utils.updateChart(stateTree, state, payload, 'yAxisMobileEnabled');
    case axisIntervalsActions.UPDATE_LOG_SCALE:
      return utils.updateChart(stateTree, state, payload, 'logScale');
    case axisIntervalsActions.UPDATE_MOBILEYAXISINTERVAL:
      return utils.updateChart(stateTree, state, payload, 'yAxisMobileInterval');
    case axisIntervalsActions.UPDATE_XAXISINTERVAL:
      return utils.updateChart(stateTree, state, payload, 'xAxisInterval');
    case axisIntervalsActions.UPDATE_MOBILE_XAXISINTERVAL:
      return utils.updateChart(stateTree, state, payload, 'mobileXAxisInterval');
    case axisIntervalsActions.UPDATE_MOBILE_XAXISINTERVAL_DIFF_THAN_DESKTOP:
      return utils.updateChart(stateTree, state, payload, 'mobileXAxisIntervalSameAsDesktop');
    case axisIntervalsActions.UPDATE_MAJOR_TICKS_ARTICLE:
      return utils.updateChart(stateTree, state, payload, 'majorTicksArticle');
    case axisIntervalsActions.UPDATE_MINOR_TICKS_ARTICLE:
      return utils.updateChart(stateTree, state, payload, 'minorTicksArticle');
    case axisIntervalsActions.UPDATE_MAJOR_TICKS_PRINT:
      return utils.updateChart(stateTree, state, payload, 'majorTicksPrint');
    case axisIntervalsActions.UPDATE_MINOR_TICKS_PRINT:
      return utils.updateChart(stateTree, state, payload, 'minorTicksPrint');
    case axisIntervalsActions.UPDATE_MAJOR_TICKS_PROMO:
      return utils.updateChart(stateTree, state, payload, 'majorTicksPromo');
    case axisIntervalsActions.UPDATE_MINOR_TICKS_PROMO:
      return utils.updateChart(stateTree, state, payload, 'minorTicksPromo');
    case axisIntervalsActions.UPDATE_HIDDEN_CATEGORIES_ARTICLE:
      return utils.updateChart(stateTree, state, payload, 'hiddenCategoriesArticle');
    case axisIntervalsActions.UPDATE_HIDDEN_CATEGORIES_PRINT:
      return utils.updateChart(stateTree, state, payload, 'hiddenCategoriesPrint');
    case axisIntervalsActions.UPDATE_HIDDEN_CATEGORIES_PROMO:
      return utils.updateChart(stateTree, state, payload, 'hiddenCategoriesPromo');
    case axisIntervalsActions.SHOW_MINOR_LABELS:
      return utils.updateChart(stateTree, state, payload, 'minorLabelsVisible');
    case axisIntervalsActions.UPDATE_ALLOW_DECIMALS:
      return utils.updateChart(stateTree, state, payload, 'allowDecimals');
    case axisIntervalsActions.UPDATE_QUARTERLY_RESULTS:
      return utils.updateChart(stateTree, state, payload, 'quarterlyResults');
    default:
      return state;
  }
}

export default axisIntervalsReducer;
